"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  Component,
  PropSync,
  Vue
} from "vue-property-decorator";
import { EventEmitter } from "events";
export class MenuController extends EventEmitter {
  constructor(collapse, lists, defalut_select, default_open) {
    super();
    this.collapse = false;
    this.default_components = "";
    this.menu_lists = [];
    this.default_open = [];
    this.collapse = collapse;
    this.menu_lists = lists;
    this.default_components = defalut_select;
    if (default_open) {
      this.default_open = default_open;
    }
  }
}
let ManagerMenuBar = class extends Vue {
  get $controller() {
    return this._controller;
  }
  collapse() {
    this.$controller.collapse = !this.$controller.collapse;
    this.$emit("collapse");
  }
  changeTeamComponent(data) {
    this.$controller.default_components = data;
    this.$emit("changeComponent", data);
  }
};
__decorateClass([
  PropSync("controller")
], ManagerMenuBar.prototype, "_controller", 2);
ManagerMenuBar = __decorateClass([
  Component({})
], ManagerMenuBar);
export {
  ManagerMenuBar as default
};
